// extracted by css-extract-rspack-plugin
export default {"aux":"aux-Er85wU","targetGood":"targetGood-_fpBEA","targetBad":"targetBad-EB_uze","selected":"selected-SDwlD1","errorIndicator":"errorIndicator-x1yIkh"};